import React from "react";

/**
 * Semaforo di conformità.
 *  - 'GREEN'  → verde  → conforme
 *  - 'YELLOW' → giallo → scadenza imminente
 *  - 'RED'    → rosso  → non conforme / scaduto
 *  - 'GRAY'   → grigio → dato non disponibile / placeholder
 *
 * Props:
 *  - colore: 'GREEN' | 'YELLOW' | 'RED' | 'GRAY'
 *  - label?: stringa opzionale a destra del bollino
 *  - size?: 'sm' | 'md' | 'lg' (default 'md')
 *  - showLegend?: bool — se true mostra anche il testo dello stato
 */
const COLOR_MAP = {
    GREEN:  { bg: "#198754", text: "Conforme",            tone: "success" },
    YELLOW: { bg: "#ffc107", text: "Scadenza imminente",  tone: "warning" },
    RED:    { bg: "#dc3545", text: "Non conforme",        tone: "danger"  },
    GRAY:   { bg: "#adb5bd", text: "N/D",                 tone: "secondary" },
};

const SIZE_MAP = {
    sm: 12,
    md: 16,
    lg: 22,
};

export default function ComplianceSemaforo({
    colore = "GRAY",
    label,
    size = "md",
    showLegend = false,
    className = "",
}) {
    const safeColor = COLOR_MAP[colore] || COLOR_MAP.GRAY;
    const px = SIZE_MAP[size] || SIZE_MAP.md;

    return (
        <span className={`d-inline-flex align-items-center ${className}`} title={safeColor.text}>
            <span
                aria-label={safeColor.text}
                style={{
                    display: "inline-block",
                    width: px,
                    height: px,
                    backgroundColor: safeColor.bg,
                    borderRadius: "50%",
                    boxShadow: "inset 0 0 0 2px rgba(255,255,255,0.4)",
                }}
            />
            {label && <span className="ms-2">{label}</span>}
            {showLegend && <span className={`ms-2 small text-${safeColor.tone}`}>{safeColor.text}</span>}
        </span>
    );
}
